export interface ILogEventPayload {
  domain: string;
  timestamp: number;
  level: TLogLevel;
  message: string;
  payload: any;
}

export enum ELogLevel {
  FATAL,
  ERROR,
  WARN,
  INFO,
  DEBUG,
  VERBOSE,
}

export type TLogLevel = Lowercase<keyof typeof ELogLevel>;

export const LogLevelNameToIdMap: Record<TLogLevel, ELogLevel> = {
  fatal: ELogLevel.FATAL,
  error: ELogLevel.ERROR,
  warn: ELogLevel.WARN,
  info: ELogLevel.INFO,
  debug: ELogLevel.DEBUG,
  verbose: ELogLevel.VERBOSE,
};

export const convertLogLevel: (level: ELogLevel | TLogLevel) => ELogLevel = (level) =>
  typeof level === 'number' ? level : LogLevelNameToIdMap[level];

export const LogLevelTitlesMap: Record<ELogLevel, string> = {
  [ELogLevel.FATAL]: 'Fatal',
  [ELogLevel.WARN]: 'Warning',
  [ELogLevel.ERROR]: 'Error',
  [ELogLevel.INFO]: 'Info',
  [ELogLevel.DEBUG]: 'Debug',
  [ELogLevel.VERBOSE]: 'Verbose',
};

export const logLevels: TLogLevel[] = ['verbose', 'debug', 'info', 'warn', 'error', 'fatal'];
